@if (toastService) {
  @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      [class]="toast.classname"
      class="rounded-2"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      (hidden)="remove(toast)"
    >
      @if (toast.template) {
        <ng-template [ngTemplateOutlet]="toast.template!"></ng-template>
      } @else {
        {{ toast.text }}
      }
    </ngb-toast>
  }
}
